import { createSelector } from 'reselect'

export const getLang = (state, props) => {
  return state.kanbo.locale.lang
}

export default createSelector(
  [
    getLang
  ],
  (
    lang
  ) => ({
    lang
  })
)
